var map = {
	"./ab.svg": "0951",
	"./anti_gaspi.svg": "fda2",
	"./cuisine_vapeur.png": "714c",
	"./egalim.svg": "8db7",
	"./equilibre.png": "f100",
	"./fraiche_et_francaise.png": "10cb",
	"./frais.png": "b0d2",
	"./legumes_du_chef.png": "8abb",
	"./local.png": "e303",
	"./menu_label.png": "8a3d",
	"./menu_malin.png": "c5b5",
	"./menu_plaisir.png": "234a",
	"./patisserie_du_chef.png": "df47",
	"./peche.png": "972b",
	"./plat_du_jour.png": "d469",
	"./produit_labellise.svg": "37a9",
	"./recette_du_chef.png": "4d8e",
	"./saison.png": "bde6",
	"./sans_gluten.png": "867c",
	"./sauce_du_chef.png": "b15f",
	"./show_cooking.png": "8b29",
	"./vbf.png": "0d35",
	"./vege.png": "a58a",
	"./veu.svg": "6e79",
	"./vf.svg": "9bbb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b3db";